// test2049
(2049 && 0);
